import { useEffect, useRef, useState } from "react";

const COPIED_RESET_DELAY = 2000;

export function useCopyToClipboard(resetDelay: number = COPIED_RESET_DELAY) {
    const [copied, setCopied] = useState(false);
    const resetTimeout = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => () => clearTimeout(resetTimeout.current), []);

    const copy = (text: string) => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        clearTimeout(resetTimeout.current);
        resetTimeout.current = setTimeout(() => setCopied(false), resetDelay);
    };

    return { copied, copy };
}
